import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { SharedModule } from "../../../../shared.module";

@Component({
    selector: 'percentage-renderer',
    templateUrl: './percentage-renderer.component.html',
    standalone: true,
    imports: [CommonModule, SharedModule]
})
export class PercentageRendererComponent implements ICellRendererAngularComp {
    public amount: number;

    initilize(params: ICellRendererParams) {
        this.amount = params.getValue();
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}
